export const FRONTEND_VERSION = process.env.REACT_APP_VERSION;
export const API_BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;
export const CHAT_MODE = process.env.REACT_APP_CHAT_MODE || 'bot';
export const WELCOME_MESSAGE =
  'สวัสดีครับ ยินดีต้อนรับเข้าสู่ LUCA ผู้ช่วยในการเรียนรู้ด้านการบัญชี หากคุณมีข้อสงสัยเกี่ยวกับการบัญชี สามารถสอบถามได้เลยครับ';
export const ENABLE_TOPIC = (process.env.REACT_APP_ENABLE_TOPIC || 'true').toLowerCase() === 'true';
export const CUNEX_STUDENT_AUTH_URL = process.env.REACT_APP_CUNEX_STUDENT_AUTH_URL ||
  'https://culab-authen-uat.azurewebsites.net/?partnerid=c8ca6227b29948d98a455f52a0a9a3a4';
export const CUNEX_STAFF_AUTH_URL = process.env.REACT_APP_CUNEX_STAFF_AUTH_URL ||
  'https://culab-authen-uat.azurewebsites.net/?partnerid=c8ca6227b29948d98a455f52a0a9a3a4';